import { createPanel } from '@atlassian/entry-point-panel';
import type { CreatePanel } from '@atlassian/entry-point-panel/types';

export const ConfigureWorkTypePanel: CreatePanel = createPanel();
